import { storyblokEditable } from "@storyblok/react";
import CountUp from "react-countup";

const Stats = ({ blok }) => {
  return (
    <section
      {...storyblokEditable(blok)}
      className="stats font-display text-left big-stats"
    >
      <div className="big-stats-wrapper">
        <div className="big-stats-energy-heading">
          <h2>
            We help you accomplish your mission with industry-beating metrics.
          </h2>
        </div>

        <div className="big-stats-energy-cards">
          <div className="stat-card">
            <CountUp prefix="$" suffix="+" end={50.0} enableScrollSpy="true" />
            <p>
              Average <br />
              donation amount
            </p>
          </div>
          <div className="stat-card">
            <CountUp prefix="$" suffix="k+" end={2} enableScrollSpy="true" />
            <p>
              Average <br />
              fundraiser amount
            </p>
          </div>
          <div className="stat-card">
            <CountUp end={43} enableScrollSpy="true" />
            <p>
              Average <br />
              donations / campaign
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
